import * as signals from 'signals';

export default {
  moveObject: new signals.Signal(),
};
